import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  language: 'en' | 'hi';
}

const Logo: React.FC<LogoProps> = ({ language }) => {
  return (
    <Link to="/" className="flex items-center space-x-2 group">
      <div className="relative w-12 h-12">
        {/* Circular background with gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary rounded-full transform group-hover:scale-105 transition-transform duration-300" />
        
        {/* Peacock feather symbol */}
        <div className="absolute inset-0 flex items-center justify-center text-white font-baloo text-2xl transform -rotate-45">
          ☸
        </div>
      </div>
      
      <div className="flex flex-col">
        <span className="text-xl font-baloo font-bold text-primary transform group-hover:scale-105 transition-transform duration-300">
          {language === 'en' ? 'Radhe Krishna' : 'राधे कृष्णा'}
        </span>
        <span className="text-sm text-gray-600 font-hindi">
          {language === 'en' ? 'Sewa Samiti' : 'सेवा समिति'}
        </span>
      </div>
    </Link>
  );
};

export default Logo; 